/**
 * Values of the `trigger` search URL param, which tells Search Completed what sent the person to the search.
 */
export enum SearchUrlTrigger {
    SpellCorrection = 'spell-correction',
    UpcomingItems = 'upcoming-items',
}
